import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// The Good Book Company — Returning-customers (reorder) campaign (adc_u83ybjumbp).
// Real spend/conversions from ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS;
// reorder sales are modeled (reorderConversions * new-customer AOV) — see realBrandData.ts.
export const campGbcReorder: FaireAdCampaignEntity = {
  token: "camp_gbc_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_good_book_company",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 150,
  startedRunningAt: "2025-11-04",
  segmentMetrics: {
    numReorderConversions: 3,
    salesDollars: 822,
    totalAdsSpendDollars: 131,
    returnOnAdSpend: 6.3,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-04T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
